import { useEffect } from 'react';
import { useMutation } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { MutationConfig } from '@/src/lib/react-query/react-query';
import { BASE_PROJECT_PATH, generateRoutePath } from '@/src/routes';

const url = `${PREFIX_URL}${BASE_PROJECT_PATH}/settings/dashboard/reports-visibility`;

type UpdateProjectMemberDashboardVisibilityResponse = { status: boolean };
type UpdateProjectMemberDashboardVisibilityDTO = {
  dashboardReportVisibility: boolean;
  projectMemberId: number;
  projectId: number;
};

export const updateProjectMemberDashboardVisibility = ({
  dashboardReportVisibility,
  projectMemberId,
  projectId,
}: UpdateProjectMemberDashboardVisibilityDTO): Promise<UpdateProjectMemberDashboardVisibilityResponse> => {
  const URL = generateRoutePath(url, { projectId });

  return axios.put(URL, {
    'dashboard-report-visibility': dashboardReportVisibility,
    'project-member-id': projectMemberId,
  });
};

type UseUpdateProjectMemberDashboardVisibilityOptions = {
  config?: MutationConfig<typeof updateProjectMemberDashboardVisibility>;
};

export const useUpdateProjectMemberDashboardVisibility = ({
  config,
}: UseUpdateProjectMemberDashboardVisibilityOptions = {}) => {
  return useMutation({
    ...config,
    onSuccess: () => {},
    mutationFn: (props) => updateProjectMemberDashboardVisibility(props),
  });
};

// Use to reset dashboard visibility if report URL is null
export const resetDashboardVisibilityIfUrlNull = async (
  projectId: number,
  members: { id: number }[],
  reportUrl: string | null
) => {
  if (!reportUrl) {
    await Promise.all(
      members.map((member) =>
        updateProjectMemberDashboardVisibility({
          dashboardReportVisibility: false,
          projectMemberId: member.id,
          projectId,
        })
      )
    );
  }
};
